// extracted by mini-css-extract-plugin
module.exports = {"MainLabel":"PlanPrice_MainLabel__7Vf+2","selected":"PlanPrice_selected__WLaaW","DiscountedLabel":"PlanPrice_DiscountedLabel__OG81j","SupportLabel":"PlanPrice_SupportLabel__RcT5b"};